import React from 'react';
import { ChefHat, MapPin, CheckCircle, ArrowRight } from 'lucide-react';
import { Button } from '../ui';
import { FOOD_CREATOR_BENEFITS, KITCHEN_OWNER_BENEFITS } from '../../constants';

const BenefitItem = ({ text }) => (
  <div className="flex items-start gap-3">
    <div className="w-6 h-6 bg-red-500 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
      <CheckCircle className="w-4 h-4 text-white" />
    </div>
    <span className="text-gray-700">{text}</span>
  </div>
);

const MarketCard = ({ icon: Icon, gradient, title, subtitle, benefits, cta, ctaVariant }) => (
  <div className="bg-white rounded-2xl border-2 border-red-100 p-8 shadow-lg hover:shadow-xl transition-all group">
    <div className="text-center mb-6">
      <div className={`w-16 h-16 bg-gradient-to-r ${gradient} rounded-full flex items-center justify-center mx-auto mb-4 group-hover:scale-110 transition-transform shadow-md`}>
        <Icon className="w-8 h-8 text-white" />
      </div>
      <h3 className="text-2xl font-bold text-gray-900 mb-2">{title}</h3>
      <p className="text-gray-600">{subtitle}</p>
    </div>
    <div className="space-y-4 mb-8">
      {benefits.map((b) => (
        <BenefitItem key={b} text={b} />
      ))}
    </div>
    <Button variant={ctaVariant} iconRight={ArrowRight} className="w-full group justify-center">
      {cta}
    </Button>
  </div>
);

const ForBothSides = () => (
  <section className="py-20 bg-gradient-to-br from-gray-50 to-slate-50">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

      <div className="text-center mb-16">
        <h2 className="text-4xl font-bold text-gray-900 mb-4">Built for Both Sides of the Market</h2>
        <p className="text-xl text-gray-600 max-w-3xl mx-auto">
          Whether you're creating amazing food or have kitchen space to share, we've got you covered.
        </p>
      </div>

      <div className="grid md:grid-cols-2 gap-8 max-w-6xl mx-auto">
        <MarketCard
          icon={ChefHat}
          gradient="from-red-500 to-red-600"
          title="For Food Creators"
          subtitle="Chefs, bakers, caterers, and food startups"
          benefits={FOOD_CREATOR_BENEFITS}
          cta="Start Cooking Today"
          ctaVariant="primary"
        />
        <MarketCard
          icon={MapPin}
          gradient="from-red-700 to-red-800"
          title="For Kitchen Owners"
          subtitle="Restaurants, commercial kitchens, and space owners"
          benefits={KITCHEN_OWNER_BENEFITS}
          cta="List Your Kitchen"
          ctaVariant="dark"
        />
      </div>

    </div>
  </section>
);

export default ForBothSides;
